import Client from './client';

export default class PartnerMemberships extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(partner, options = {}) {
    return this.makeRequest(`${this.host}/partners/${partner}/memberships`, options);
  }

  post(partner, options = {}) {
    return this.makeRequest(`${this.host}/partners/${partner}/memberships`, {
      ...options,
       method: 'POST',
    });
  }

  getVersions(partner, options = {}) {
    return this.makeRequest(`${this.host}/partners/${partner}/memberships/versions`, options);
  }

  getById(partner, id, options = {}) {
    return this.makeRequest(`${this.host}/partners/${partner}/memberships/${id}`, options);
  }

  putById(partner, id, options = {}) {
    return this.makeRequest(`${this.host}/partners/${partner}/memberships/${id}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteById(partner, id, options = {}) {
    return this.makeRequest(`${this.host}/partners/${partner}/memberships/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
